import React from "react";
import { RecoilRoot } from "recoil";
import { HelmetProvider } from "react-helmet-async";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/login/Login";
import SignupMobilePage from "./pages/login/widgetMobile/SignupMobilePage";
import FindPasswordMobilePage from "./pages/login/widgetMobile/FindPasswordMobilePage";
import Home from "./pages/home/Home";
import AdsLandingPage from "./pages/adsLanding/AdsLandingPage";
import ZoomSettingsInitializer from "./components/ZoomSettingsInitializer";
import LoadingOverlay from "./components/common/LoadingOverlay";
import { useAuth } from "./hooks/useAuth";
import "./styles/variables.css";
import "./styles/global.css";
import "./App.css";

function AppContent() {
  const { loading } = useAuth();
  const [isMobile, setIsMobile] = React.useState(false);
  const buildIdRef = React.useRef(process.env.REACT_APP_BUILD_ID);

  // 배포 후 캐시된 이전 버전 감지: 서버 version.json과 빌드 시 주입된 ID 비교 후 다르면 새로고침
  React.useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    const buildId = buildIdRef.current;
    if (!buildId) return;

    const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5분마다

    // const checkVersion = () => {
    //   fetch(`${window.location.origin}/version.json?t=${Date.now()}`, {
    //     cache: "no-store",
    //   })
    //     .then((res) => (res.ok ? res.json() : null))
    //     .then((data) => {
    //       if (data && data.buildId && data.buildId !== buildId) {
    //         window.location.reload();
    //       }
    //     })
    //     .catch(() => {});
    // };

    // checkVersion();
    // const intervalId = setInterval(checkVersion, CHECK_INTERVAL_MS);
    // const onVisible = () => {
    //   if (document.visibilityState === "visible") checkVersion();
    // };
    // document.addEventListener("visibilitychange", onVisible);
    // return () => {
    //   clearInterval(intervalId);
    //   document.removeEventListener("visibilitychange", onVisible);
    // };
  }, []);

  React.useEffect(() => {
    // 초기 모바일 감지 (한 번만, 더 정확한 방법 사용)
    const initialWidth = window.visualViewport?.width || window.innerWidth;
    const initialIsMobile = initialWidth <= 768;
    setIsMobile(initialIsMobile);

    // 모바일로 감지되면 리사이즈 이벤트 무시 (옛날 디자인으로 넘어가는 것 방지)
    if (initialIsMobile) {
      return;
    }

    // 데스크톱인 경우에만 리사이즈 이벤트 처리
    const checkMobile = () => {
      const width = window.visualViewport?.width || window.innerWidth;
      setIsMobile(width <= 768);
    };

    // 디바운싱하여 너무 자주 발생하지 않도록
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(checkMobile, 100);
    };

    window.addEventListener("resize", handleResize);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleResize);
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handleResize);
      }
      clearTimeout(resizeTimeout);
    };
  }, []);

  return (
    <>
      <ZoomSettingsInitializer />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ads" element={<AdsLandingPage />} />
          <Route path="/guide" element={<Home />} />
          <Route path="/guide/:slug" element={<Home />} />
          <Route path="/login" element={<Login />} />
          {isMobile && (
            <>
              <Route path="/signup" element={<SignupMobilePage />} />
              <Route
                path="/find-password"
                element={<FindPasswordMobilePage />}
              />
            </>
          )}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
      <LoadingOverlay isVisible={loading} message="로그인 중..." />
    </>
  );
}

function App() {
  return (
    <RecoilRoot>
      <HelmetProvider>
        <AppContent />
      </HelmetProvider>
    </RecoilRoot>
  );
}

export default App;
